import { render, staticRenderFns } from "./DocumentsFilters.vue?vue&type=template&id=10fc400d&scoped=true&"
import script from "./DocumentsFilters.vue?vue&type=script&lang=ts&"
export * from "./DocumentsFilters.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsFilters.vue?vue&type=style&index=0&id=10fc400d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fc400d",
  null
  
)

export default component.exports